import Vue from "vue";
import Vuex from "vuex";

import data from "../services/data";
import fn from "../services/fn";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pharmacies: []
  },
  mutations: {
    SET_PHARMACIES: (state, pharmacies) => {
      state.pharmacies = pharmacies;
    },
    UPDATE_PHARMACY: (state, pharmacy) => {
      const index = state.pharmacies.findIndex(i => i.id == pharmacy.id);
      if (index == -1) {
        console.error("can't find edited item in the store");
      } else {
        Object.assign(state.pharmacies[index], pharmacy);
      }
    },
    DELETE_PHARMACY: (state, pharmacy) => {
      const index = state.pharmacies.indexOf(pharmacy);
      state.pharmacies.splice(index, 1);
    },
    ACTIVATE_PHARMACY: (state, pharmacy) => {
      const index = state.pharmacies.findIndex(i => i.id == pharmacy.id);
      if (index == -1) {
        console.error("can't find activated item in the store");
      } else {
        Object.assign(state.pharmacies[index], pharmacy);
      }
    }
  },
  actions: {
    loadPharmacies({ commit }) {
      data
        .loadPharmacies()
        .then(pharmacies => commit("SET_PHARMACIES", pharmacies));
    },

    updatePharmacy({ commit }, pharmacy) {
      data
        .updatePharmacy(pharmacy)
        .then(() => commit("UPDATE_PHARMACY", pharmacy));
    },

    deletePharmacy({ commit }, pharmacy) {
      data
        .deletePharmacy(pharmacy.id)
        .then(() => commit("DELETE_PHARMACY", pharmacy));
    },

    activatePharmacy({ commit }, pharmacy) {
      pharmacy.activated = true;
      fn.activatePharmacy(pharmacy.id).then(() =>
        commit("ACTIVATE_PHARMACY", pharmacy)
      );
    }
  },
  getters: {
    getPharmacies: state => {
      return state.pharmacies;
    }
  },
  modules: {}
});
